import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Box, Typography, Grid } from "@mui/material";
import { SchemaCard } from "./components/SchemaCard";
import HouseInfo from "./Pages/HouseInfo";
import ParentInfo from "./Pages/ParentInfo";
import ClassInfo from "./Pages/ClassInfo";
import TransportInfo from "./Pages/TransportInfo";
import FeeInfo from "./Pages/FeeInfo";
import CategoryInfo from "./Pages/CategoryInfo";
import DocumentInfo from "./Pages/DocumentInfo";
import CustomFieldsInfo from "./Pages/CustomFieldsInfo";
import {
  People,
  Home,
  School,
  DirectionsBus,
  AttachMoney,
  LocalOffer,
  Description,
  Settings,
} from "@mui/icons-material";

const DASHBOARD_CARDS = [
  {
    id: "house",
    path: "house-information",
    name: "House Information",
    description: "Update house name, color, and role assignments",
    icon: Home,
  },
  // {
  //   id: "parent",
  //   path: "parent-information",
  //   name: "Parent Information",
  //   description: "Update parent/guardian details",
  //   icon: People,
  // },
  {
    id: "class",
    path: "roll-number",
    name: "Roll Number",
    description: "Update roll number",
    icon: School,
  },
  // {
  //   id: "transport",
  //   path: "transport-information",
  //   name: "Transport Information",
  //   description: "Update bus route, stop, and transport fee details",
  //   icon: DirectionsBus,
  // },
  // {
  //   id: "fee",
  //   path: "fee-mapping",
  //   name: "Fee Mapping",
  //   description: "Update fee structure, and payment plans",
  //   icon: AttachMoney,
  // },
  // {
  //   id: "category",
  //   path: "category-caste",
  //   name: "Category / Caste",
  //   description: "Update category, caste, and minority status",
  //   icon: LocalOffer,
  // },
  // {
  //   id: "documents",
  //   path: "document-status",
  //   name: "Document Status",
  //   description: "Update document submission and verification ",
  //   icon: Description,
  // },
  // {
  //   id: "custom",
  //   path: "custom-fields",
  //   name: "Custom Fields",
  //   description: "Update school-specific custom field values",
  //   icon: Settings,
  // },
];

function BulkEditDashboard() {
  const navigate = useNavigate();

  return (
    <Box >
      <Box
        sx={{
          // maxWidth: "px",
          margin: "0 auto",
          padding: { xs: "32px 16px", sm: "32px 24px", lg: "32px 32px" },
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h4"
            sx={{ color: "#111827", mb: 1, fontWeight: 600 }}
          >
            Student Bulk Edit
          </Typography>
          <Typography sx={{ color: "#6B7280" }}>
            Update student data in bulk using schema-specific templates.
          </Typography>
        </Box>

        <Grid
          container
          spacing={3}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
              xl: "repeat(4, 1fr)",
            },
          }}
        >
          {DASHBOARD_CARDS.map((card) => (
            <Grid item key={card.id}>
              <SchemaCard
                icon={<card.icon style={{ width: 24, height: 24 }} />}
                title={card.name}
                description={card.description}
                onSelect={() => navigate(card.path)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default function BulkEditMain() {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route index element={<BulkEditDashboard />} />
      <Route
        path="house-information"
        element={
          <HouseInfo onBack={() => navigate("/student-management/bulkEdit")} />
        }
      />
      <Route
        path="parent-information"
        element={
          <ParentInfo onBack={() => navigate("/student-management/bulkEdit")} />
        }
      />
      <Route
        path="roll-number"
        element={
          <ClassInfo onBack={() => navigate("/student-management/bulkEdit")} />
        }
      />
      <Route
        path="transport-information"
        element={
          <TransportInfo
            onBack={() => navigate("/student-management/bulkEdit")}
          />
        }
      />
      <Route
        path="fee-mapping"
        element={
          <FeeInfo onBack={() => navigate("/student-management/bulkEdit")} />
        }
      />
      <Route
        path="category-caste"
        element={
          <CategoryInfo
            onBack={() => navigate("/student-management/bulkEdit")}
          />
        }
      />
      <Route
        path="document-status"
        element={
          <DocumentInfo
            onBack={() => navigate("/student-management/bulkEdit")}
          />
        }
      />
      <Route
        path="custom-fields"
        element={
          <CustomFieldsInfo
            onBack={() => navigate("/student-management/bulkEdit")}
          />
        }
      />
    </Routes>
  );
}
